import type { DriverBucketRow, DriverBucketTable } from "./buildChartConfig";

// Kept in sync with DriverActivityReportComponent::DRIVER_ID_PLACEHOLDER so route
// generation stays in Ruby; we only substitute the id client-side.
const DRIVER_ID_PLACEHOLDER = "__DRIVER_ID__";

type Inputs = {
  tableBodyElement: HTMLElement;
  scopeElement: HTMLElement;
  bucketTable: DriverBucketTable;
  userPathTemplate: string;
};

// Replaces the driver table with the full ranking for a single bucket and updates
// the "Showing:" label. Pure DOM work so it is unit-testable without a chart.
export function renderBucketTable({ tableBodyElement, scopeElement, bucketTable, userPathTemplate }: Inputs): void {
  scopeElement.textContent = bucketTable.label;
  tableBodyElement.innerHTML = bucketTable.rows
    .map((row, index) => rowHtml(row, index, userPathTemplate))
    .join("");
}

function rowHtml(row: DriverBucketRow, index: number, userPathTemplate: string): string {
  const href = userPathTemplate.replace(DRIVER_ID_PLACEHOLDER, encodeURIComponent(row.driver_id));
  return `
    <tr class="border-b border-primary/10">
      <td class="px-3 py-3 text-primary/60">${index + 1}</td>
      <td class="px-3 py-3 text-primary">
        <a href="${href}" class="text-primary hover:underline">${escapeHtml(row.driver_name)}</a>
      </td>
      <td class="px-3 py-3 text-right text-primary">${row.ride_count}</td>
      <td class="px-3 py-3 text-right text-primary/70">${row.percent}%</td>
    </tr>`;
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
